export const MY_ACCOUNT_PAGES_URL_SUFFIX = 'shelter';
export const DONATION_PAGES_URL_SUFFIX = 'donation';
